import { createFetchTypes } from '../../utils/createFetchTypes';

export const DELETE_REPORT = 'DELETE_REPORT';
export const UPDATE_CREATE_REPORT = 'UPDATE_CREATE_REPORT';
export const DELETE_IMAGE_FROM_REPORT = 'DELETE_IMAGE_FROM_REPORT';
export const SET_ALL_TYPES = 'SET_ALL_TYPES';
export const CANCEL_CHANGE = 'CANCEL_CHANGE';
export const SELECT_THE_REPORT = 'SELECT_THE_REPORT';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const RESET_SELECT_THE_REPORT = 'RESET_SELECT_THE_REPORT';
export const SELECT_LOCATIONS_INITIAL_DIALOG = 'SELECT_LOCATIONS_INITIAL_DIALOG';

// ************** createFetchType

export const GET_PATIENT_REPORTS = createFetchTypes('GET_PATIENT_REPORTS');
